import { inject, Injectable } from '@angular/core';
import {
  CreateEmptyEnrollmentRequest,
  EnrollmentAnalyticsRequest,
  CreateEnrollmentRequest,
  EnrollmentService,
  EnrollmentSupportEmailRequest,
  UpdateEnrollmentRequest,
} from '@app/resources/services/enrollment.service';

@Injectable()
export class EnrollmentAPIService {
  private readonly enrollmentService = inject(EnrollmentService);

  getEnrollmentData(enrollmentId: string) {
    return this.enrollmentService.find(enrollmentId);
  }

  updateEnrollment(updateEnrollmentRequest: UpdateEnrollmentRequest) {
    return this.enrollmentService.update(updateEnrollmentRequest);
  }

  completeEnrollment(enrollmentId: string) {
    return this.enrollmentService.complete(enrollmentId);
  }

  createEnrollment(
    createEnrollmentRequest: CreateEnrollmentRequest,
    updateEnrollmentRequest: UpdateEnrollmentRequest,
    serialNumber: string
  ) {
    return this.enrollmentService.create(createEnrollmentRequest, updateEnrollmentRequest, serialNumber);
  }

  sendSupportEmail(enrollmentSupportEmailRequest: EnrollmentSupportEmailRequest) {
    return this.enrollmentService.sendSupportEmail(enrollmentSupportEmailRequest);
  }

  updateEnrollmentData(updateEnrollmentRequest: UpdateEnrollmentRequest) {
    return this.enrollmentService.updateEnrollmentData(updateEnrollmentRequest);
  }

  createEnrollmentAnalytics(createEnrollmentAnalyticsRequest: EnrollmentAnalyticsRequest) {
    return this.enrollmentService.createEnrollmentAnalytics(createEnrollmentAnalyticsRequest);
  }
}
